import React, { useState, useEffect, createContext, useContext, useRef } from 'react';
import './index.css';
import { supabase } from './lib/supabase';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ZmenaHesla from './components/ZmenaHeslaModal';
export const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);
export default function App() {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPasswordReset, setShowPasswordReset] = useState(false);
  const [deaktivovan, setDeaktivovan] = useState(false);
  const initialized = useRef(false);
  const fetchProfile = async (authUser) => {
    if (!authUser) {
      setProfile(null);
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await supabase
        .from('uzivatele')
        .select('*, vedouci:vedouci_id(jmeno)')
        .eq('id', authUser.id)
        .single();
      if (data) {
        // Kontrola jestli je účet aktivní
        if (!data.aktivni) {
          await supabase.auth.signOut();
          setProfile(null);
          setUser(null);
          setDeaktivovan(true);
          setLoading(false);
          return;
        }
        setDeaktivovan(false);
        setProfile(data);
        setUser(authUser);
      } else {
        setProfile(null);
        setUser(null);
      }
    } catch {
      setProfile(null);
      setUser(null);
    }
    setLoading(false);
  };
  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.includes('access_token')) {
      const params = new URLSearchParams(hash.substring(1));
      const type = params.get('type');
      if (type === 'recovery' || type === 'invite') {
        setShowPasswordReset(true);
      }
    }
    supabase.auth.getSession().then(({ data: { session } }) => {
      fetchProfile(session?.user ?? null);
      initialized.current = true;
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (!initialized.current) return;
      if (event === 'PASSWORD_RECOVERY') {
        setShowPasswordReset(true);
        fetchProfile(session?.user ?? null);
        return;
      }
      if (event === 'SIGNED_IN' || event === 'SIGNED_OUT' || event === 'USER_UPDATED') {
        fetchProfile(session?.user ?? null);
      }
    });
    const timeout = setTimeout(() => setLoading(false), 5000);
    return () => {
      subscription.unsubscribe();
      clearTimeout(timeout);
    };
  }, []);
  const login = async (email, heslo) => {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password: heslo });
    if (error) throw new Error('Nesprávný email nebo heslo');
    return data;
  };
  const logout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    setProfile(null);
  };
  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#111' }}>
      <div style={{ color: '#fff', fontFamily: 'DM Sans, sans-serif', opacity: 0.5 }}>Načítám…</div>
    </div>
  );
  return (
    <AuthContext.Provider value={{ user, profile, login, logout }}>
      {user && profile ? <Dashboard /> : (
        <Login deaktivovan={deaktivovan} />
      )}
      {showPasswordReset && (
        <ZmenaHesla onClose={() => setShowPasswordReset(false)} />
      )}
    </AuthContext.Provider>
  );
}
